module.exports = __webpack_public_path__ + "img/3.05c6a319.jpg";